import { connect } from 'react-redux';
import { AppState } from '../reducers';
import { entitiesSelector, entityErrorMessageSelector } from './entities.selector';
import SearchResultsComponent, { SearchResultsProps, SearchResultsStateProps } from './SearchResults.component';

export default connect<SearchResultsStateProps, {}, SearchResultsProps, AppState>((state: AppState) => ({
  entities: entitiesSelector(state),
  errorMessage: entityErrorMessageSelector(state),
}))(SearchResultsComponent);
